<SearchInput
    label={searchLabel}
    placeholder={searchPlaceholder}
    bind:value={searchValue}
/>
<List>
    <thead slot="header">
        <ListElement header>
            {#if useSelectAll}
            <CheckboxCell
                disabled={searchValue.length > 0}
                header
                bind:checked={isAllSelected}
                text={selectAllHeaderText}
                on:change={e => handleSelectAllToggled(e.detail)}
            />
            {/if}
            <slot name="headerTemplate"></slot>
        </ListElement>
    </thead>
    <tbody slot="body">
        {#each filteredItems as item}
            <ListElement
                bind:checked={item.checked}
                checkOnClick
                on:click={handleSelectedItemsChanged}
            >
                {#if useSelectAll}
                <CheckboxCell
                    bind:checked={item.checked}
                    text={checkboxText}
                    on:change={handleSelectedItemsChanged}
                />
                {/if}
                <slot name="rowTemplate" {item} />
            </ListElement>
        {/each}
    </tbody>
</List>

<script>
    import { onMount } from "svelte";
    import SearchInput from "@itslearning/prometheus/assets/inputs/SearchInput/v1/SearchInput.svelte";
    import CheckboxCell from "@itslearning/prometheus/assets/lists/CheckboxCell/v1/CheckboxCell.svelte";
    import List from "@itslearning/prometheus/assets/lists/List/v1/List.svelte";
    import ListElement from "@itslearning/prometheus/assets/lists/ListElement/v1/ListElement.svelte";

    export let checkboxText = "Checked";
    export let searchFunction = (searchTerm) => (item) => true;
    export let searchLabel = "Search";
    export let searchPlaceholder = "Search";
    export let searchValue;
    export let isAllSelected;
    export let items = [];
    export let selectAllHeaderText = "Check all";
    export let useSelectAll = true;

    $: filteredItems = items.filter(searchFunction(searchValue));
    $: isAllSelected = items.length > 0 && items.every(i => i.checked);

    onMount(() => {
        handleSelectedItemsChanged();
    });

    const handleSelectAllToggled = ({ checked }) => {
        items.forEach((item) => {
            item.checked = checked;
        });

        items = items;
    };

    const handleSelectedItemsChanged = () => {
        isAllSelected = items.length > 0 && items.every(i => i.checked);
    };
</script>
